export const DEFAULT_RESPONSE_LIMIT = 100;

export const DEFAULT_QUERY_OPTIONS = {
  gcTime: 10 * 60 * 1000,
  staleTime: 10 * 60 * 1000,
};
